import { Routes } from '@angular/router';
import { loginGuard } from 'app/guards/login.guard';
import {blueprintsGuard, objectEditorGuard} from './app.resolver';

export const APP_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'blueprints',
  },
  {
    path: 'login',
    canActivate: [loginGuard],
    loadChildren: () => import('./auth/auth.routes').then((m) => m.AUTH_ROUTES),
    data: { title: 'UGOL.Авторизация' },
  },
  {
    path: 'blueprints',
    canActivate: [blueprintsGuard],
    loadChildren: async () =>
      (await import('./modules/ugol-blueprints/ugol-blueprints.routes')).BLUEPRINTS_ROUTES,
    data: { title: 'Чертежи' },
  },
  {
    path: 'object-editor',
    canActivate: [objectEditorGuard],
    loadChildren: () =>
      import('./modules/object-editor/object-editor.module').then((m) => m.ObjectEditorModule),
    data: { title: 'Редактор объектов' },
  },
  {
    path: '**',
    redirectTo: 'blueprints',
  },
];
